import { useQuery } from '@tanstack/react-query';

import { fetchCategoryById } from '../services/svp';

export const useCategory = (categoryId?: number) => {
  return useQuery({
    queryKey: ['category', categoryId],
    queryFn: () => fetchCategoryById(categoryId!),
    enabled: Boolean(categoryId),
  });
};
